import Tab from 'react-bootstrap/Tab'
import BSTabs from 'react-bootstrap/Tabs'
import { useCookies } from 'react-cookie'

import Icon from '@/components/Icon/Icon'

type Props = {
  children?: React.ReactNode
  disableTable?: boolean
}

const Tabs = ({ children, disableTable }: Props) => {
  const [cookies, setCookies] = useCookies(['cardListView'])
  const view = cookies.cardListView || 'card'
  return (
    <div className='align-items-end d-flex justify-content-between'>
      <div>{children}</div>
      <div className='d-flex flex-column h-100 justify-content-end'>
        <BSTabs activeKey={view} onSelect={(k) => setCookies('cardListView', k, { path: '/' })}>
          <Tab eventKey='card' title={<Icon icon='image' />} />
          {!disableTable && <Tab eventKey='table' title={<Icon icon='table' />} />}
          <Tab eventKey='text' title={<Icon icon='font' />} />
        </BSTabs>
      </div>
    </div>
  )
}

export default Tabs
